import { Button, ButtonMode } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { useContext } from 'react';
import { SessionContext } from '../../context/SessionContext';
import styles from './Terms.module.scss';

const cx = classNames.bind(styles);

export default function ChatToS(): React.ReactElement {
  const { setAcceptedTerms } = useContext(SessionContext);

  return (
    <div className={cx('body')}>
      <p>
        Before we start please review our{' '}
        <a href="https://www.fitch.group/terms-of-use" target="_blank" rel="noreferrer">
          Terms and Conditions
        </a>
        . By proceeding, you accept the Terms and Conditions necessary to use the CreditSights Genie.
      </p>
      <p>
        The content generated by CreditSights Genie constitutes the proprietary intellectual property of CreditSights
        and is accessed by you subject to the Terms of Use. Any reuse, reproduction, or quotation of this material in
        press or other mediums, without explicit prior authorization from CreditSights, is strictly prohibited.
      </p>
      <div>
        <Button className={cx('btn')} mode={ButtonMode.SECONDARY} onClick={setAcceptedTerms}>
          Yes, I accept
        </Button>
      </div>
    </div>
  );
}
